/**
 * Reusable Card Components
 */

// eslint-disable-next-line simple-import-sort/imports
import { type App } from '~/app';
import { defineAsyncComponent } from 'vue';

export default (app: App) => {
	app.logger.debug('[Stockland FE] Initialise Reusable Card Components');
	app.vueApp.component(
		'event-card',
		defineAsyncComponent(async () => import('./event-card/EventCard.vue'))
	);
	app.vueApp.component(
		'image-card-modal',
		defineAsyncComponent(async () => import('./image-card-modal/ImageCardModal.vue'))
	);
	app.vueApp.component(
		'contact-card',
		defineAsyncComponent(async () => import('./contact-card/ContactCard.vue'))
	);
	app.vueApp.component(
		'image-tile-card',
		defineAsyncComponent(async () => import('./image-tile-card/ImageTileCard.vue'))
	);
	app.vueApp.component(
		'llc-event-card',
		defineAsyncComponent(async () => import('./llc-event-card/LlcEventCard.vue'))
	);
	app.vueApp.component(
		'llc-community-card',
		defineAsyncComponent(async () => import('./llc-community-card/LlcCommunityCard.vue'))
	);
	app.vueApp.component(
		'llc-community-card-mobile',
		defineAsyncComponent(async () => import('./llc-community-card/LlcCommunityCardMobile.vue'))
	);
	app.vueApp.component(
		'llc-amenity-card',
		defineAsyncComponent(async () => import('./llc-amenity-card/LlcAmenityCard.vue'))
	);
	app.vueApp.component(
		'llc-amenity-card-mobile',
		defineAsyncComponent(async () => import('./llc-amenity-card/LlcAmenityCardMobile.vue'))
	);
	app.vueApp.component(
		'product-card',
		defineAsyncComponent(async () => import('../card/product-card/ProductCard.vue'))
	);
	return function destroyComponents() {
		// Component de-registration
		app.logger.debug('[Stockland FE] Card Components destroyed');
	};
};
